import { apolloLink } from './apolloLinks';
import { ApolloClient } from '@apollo/client';
import { apolloCache } from './apolloCacheConfig';
import { LOCAL_SCHEMA } from './store/localSchema';

export const apolloClient = new ApolloClient({
  link: apolloLink,
  cache: apolloCache,
  typeDefs: LOCAL_SCHEMA,
});
